<script>
import { VDataFooter } from 'vuetify/lib'
import { EButton, EDivider, ESelect } from '../index'

import { getSlot } from 'vuetify/lib/util/helpers'
import { VSelect } from 'vuetify/lib/components'

export default {
  name: 'EDataFooter',
  extends: VDataFooter,
  props: {
    prevIcon: {
      type: String,
      default: 'icon-arrow-left',
    },
    nextIcon: {
      type: String,
      default: 'icon-arrow-right',
    },
  },
  computed: {
    isMobile() {
      return this.$vuetify.breakpoint.mobile
    },
  },
  methods: {
    genDivider() {
      return this.$createElement('div', { staticClass: 'v-data-footer__divider' }, [
        this.$createElement(EDivider, {
          props: {
            vertical: true,
          },
        }),
      ])
    },
    genIcon(click, disabled, label, icon) {
      return this.$createElement(EButton, {
        props: {
          disabled: disabled || this.disablePagination,
          icon: icon,
          variant: 'tertiary',
          small: true,
        },
        on: {
          click,
        },
        attrs: {
          'aria-label': label,
        },
      })
    },
    onChangePage(page) {
      this.updateOptions({ page })
    },
    genPageSelect() {
      const pages = [...Array.from({ length: this.pagination.pageCount }, (_, i) => i + 1)]
      let value = this.options.page
      return this.$createElement(
        'div',
        {
          staticClass: 'v-data-footer__select',
        },
        [
          !this.isMobile && this.$vuetify.lang.t('$vuetify.dataTable.currentPage'),
          this.$createElement(ESelect, {
            attrs: {
              'aria-label': this.$vuetify.lang.t(this.itemsPerPageText),
            },
            props: {
              disabled: this.disableItemsPerPage,
              small: true,
              items: pages,
              value,
              hideDetails: true,
              auto: true,
              minWidth: '75px',
            },
            on: {
              input: this.onChangePage,
            },
          }),
        ]
      )
    },
  },
  render() {
    return this.$createElement(
      'div',
      {
        staticClass: 'v-data-footer',
        class: 'e-data-footer',
      },
      [
        this.pagination.itemsLength ? this.genPaginationInfo() : null,
        getSlot(this, 'prepend'),
        this.genPageSelect(),
        this.genDivider(),
        this.genIcons(),
      ]
    )
  },
}
</script>
